// app/assets/webpack_entry/redux_global_store.wjs.jsx depends on a wildcard
// import of this file, so it's simplest to maintain this for now. The next
// step to improve this would be to rewrite all pages using redux_global_store
// in Webpack + Typescript with simplified imports to avoid passing globals around.

/* eslint-disable no-barrel-files/no-barrel-files */
export { MessagesInbox } from './messages_inbox/reducer';
export { AnalyticsDashboard } from './analytics_dashboard/reducer';
export { SearchResults } from './search_results/reducer';
export { ProfileVisitorCards } from './profile_visitor_cards/reducer';
/* eslint-enable no-barrel-files/no-barrel-files */

// just for fun
export function actions(state = require('./action_types.wjs.jsx')) {
  return state;
}
